// export const API_URL = "http://192.168.1.10:8000/api/v1/";
export const API_URL = process.env.NODE_ENV === "production" ? "https://zik.inpt.fr/api/v1/" : "http://127.0.0.1:8000/api/v1/";
export const BAND_APP_URL = API_URL+"bands/";
export const BOOKING_APP_URL = API_URL+"bookings/";
export const AUTH_URL = API_URL+"rest-auth/";
export const USERS_URL = API_URL+"users/";
export const RESPOND_USER_VERIF = USERS_URL+"respondUserVerif/";
export const REQUEST_USER_VERIF = USERS_URL+"requestUserVerif/";
